import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LoadingService } from '../../shared/loading';
import { LoggingService } from '../../shared/services/logging';
import * as fromRoot from '../../store';

/** Response shape from GET api/EmployeeBaseRate */
export interface EmployeeBaseRateDto {
    EmployeeListID: string;
    EmployeeName: string;
    EmpRateType: string;
    BaseRate?: number;
}

/** Update request body for PUT api/EmployeeBaseRate (same shape as other APIs). */
export interface EmployeeBaseRateUpdateRequest {
    EmployeeBaseRateList: EmployeeBaseRateDto[];
}

/** Update response includes Items array */
export interface EmployeeBaseRateUpdateResponse {
    Items?: EmployeeBaseRateDto[];
    StatusCode?: number;
    ErrorMessages?: string[];
}

@Injectable({ providedIn: 'root' })
export class EmployeeBaseRateService extends LoadingService {
    private uri = `${environment.apiLocation}/EmployeeBaseRate`;

    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }

    get(activeOnly?: boolean | null): Observable<EmployeeBaseRateDto[]> {
        super.Load();
        const params: { activeOnly?: string } = {};
        if (activeOnly != null) {
            params.activeOnly = String(activeOnly);
        }
        return this.http.get<EmployeeBaseRateDto[]>(this.uri, { params }).pipe(
            tap(data => {
                super.Stop();
                this.log.verbose({
                    type: 'EmployeeBaseRateService:get',
                    data
                });
            })
        );
    }

    put(request: EmployeeBaseRateUpdateRequest): Observable<EmployeeBaseRateUpdateResponse> {
        return this.http
            .put<EmployeeBaseRateUpdateResponse>(this.uri, request)
            .pipe(
                tap(resp =>
                    this.log.verbose({
                        type: 'EmployeeBaseRateService:put',
                        resp
                    })
                )
            );
    }
}
